module.exports = __webpack_public_path__ + "static/media/5.5fc9ce28.png";